import DirectMessageIframe from "./DirectMessageIframe";

export default DirectMessageIframe;
